// VERSION 1.0.0
// AUTHOR: AGALYA

import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	changeStatusTransferLogFailure,
	changeStatusTransferLogResponseChanged,
	changeStatusTransferLogSuccess,
	fetchTransferLogListFailure,
	fetchTransferLogListResponseChanged,
	fetchTransferLogListSuccess,
	getMemberApproveListFailure,
	getMemberApproveListResponseChanged,
	getMemberApproveListSuccess,
	memberForTransferCenterFailure,
	memberForTransferCenterResponseChanged,
	memberForTransferCenterSuccess,
} from './common-transfer-log.action';
import CommonTransferLogActionTypes from './common-transfer-log.types';
import {
	changeStatusTransferLogData,
	fetchTransferLogData,
	getMemberApproveListData,
	memberForTransferCenterData,
} from './common-transfer-log.service';

/*************** FETCH TRANSFER LOG START  ******************/
export function* fetchTransferLogDetails({ payload }: any) {
	try {
		const {
			databaseName,
			companyID,
			branchID,
			centerID,
			groupID,
			selectStatus,
			limit,
			transferType,
		} = payload;
		const key = 'FetchTransferLogKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			Status: selectStatus,
			Limit: limit,
			TransferType: transferType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchTransferLogData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchTransferLogListFailure(responseData.data));
		} else {
			yield put(fetchTransferLogListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchTransferLogListFailure(error));
	}
}

export function* resetFetchTransferLogListResponse() {
	yield put(fetchTransferLogListResponseChanged());
}

export function* onFetchTransferLogList() {
	yield takeLatest(
		CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_START,
		fetchTransferLogDetails,
	);
}

export function* onFetchTransferLogListResponseReset() {
	yield takeLatest(
		CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_RESPONSE_RESET_START,
		resetFetchTransferLogListResponse,
	);
}
/*************** FETCH TRANSFER LOG END  ******************/

/***************  GET MEMBER APPROVE LIST START  ******************/
export function* getMemberApproveDetails({ payload }: any) {
	try {
		const { databaseName, companyID, transferID } = payload;
		const key = 'GetMemberApproveListKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			TransferID: transferID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getMemberApproveListData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberApproveListFailure(responseData.data));
		} else {
			yield put(getMemberApproveListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberApproveListFailure(error));
	}
}

export function* resetGetMemberApproveListResponse() {
	yield put(getMemberApproveListResponseChanged());
}

export function* onGetMemberApproveList() {
	yield takeLatest(
		CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_START,
		getMemberApproveDetails,
	);
}

export function* onGetMemberApproveListResponseReset() {
	yield takeLatest(
		CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_RESPONSE_RESET_START,
		resetGetMemberApproveListResponse,
	);
}
/***************  GET MEMBER APPROVE LIST END  ******************/

/***************  CHANGE STATUS TRANSFER LOG START ******************/
export function* changeStatusTransferLogDetails({ payload }: any) {
	try {
		const { databaseName, approvedStatus, completeStatus, userID, transferLogID, actionType } =
			payload;
		const key = 'ChangeStatusTransferLogKey';
		const jsonData = {
			DatabaseName: databaseName,
			ApprovedStatus: approvedStatus,
			CompleteStatus: completeStatus,
			UserID: userID,
			TransferLogID: transferLogID,
			actionType: actionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(changeStatusTransferLogData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(changeStatusTransferLogFailure(responseData.data));
		} else {
			yield put(changeStatusTransferLogSuccess(responseData.data));
		}
	} catch (error) {
		yield put(changeStatusTransferLogFailure(error));
	}
}

export function* resetChangeStatusTransferLogResponse() {
	yield put(changeStatusTransferLogResponseChanged());
}

export function* onChangeStatusTransferLog() {
	yield takeLatest(
		CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_START,
		changeStatusTransferLogDetails,
	);
}

export function* onChangeStatusTransferLogResponseReset() {
	yield takeLatest(
		CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_RESPONSE_RESET_START,
		resetChangeStatusTransferLogResponse,
	);
}
/***************  CHANGE STATUS TRANSFER LOG END ******************/

/*********  MEMBER FOR TRANSFER CENTER START *********/
export function* transferCenterMemberDetails({ payload }: any) {
	try {
		const { branchID, centerID, groupID, companyID, databaseName } = payload;
		const key = 'GetMemberForTransferCenterKey';
		const jsonData = {
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberForTransferCenterData, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(memberForTransferCenterFailure(responseData.data));
		} else {
			yield put(memberForTransferCenterSuccess(responseData.data));
		}
	} catch (error) {
		yield put(memberForTransferCenterFailure(error));
	}
}

export function* resetMemberForTransferCenterResponse() {
	yield put(memberForTransferCenterResponseChanged());
}

export function* onMemberForTransferCenter() {
	yield takeLatest(
		CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_START,
		transferCenterMemberDetails,
	);
}

export function* onMemberForTransferCenterResponseReset() {
	yield takeLatest(
		CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_RESPONSE_RESET_START,
		resetMemberForTransferCenterResponse,
	);
}
/*********  MEMBER FOR TRANSFER CENTER END *********/

export function* commonTransferLogSaga() {
	yield all([
		call(onFetchTransferLogList),
		call(onFetchTransferLogListResponseReset),
		call(onGetMemberApproveList),
		call(onGetMemberApproveListResponseReset),
		call(onChangeStatusTransferLog),
		call(onChangeStatusTransferLogResponseReset),
		call(onMemberForTransferCenter),
		call(onMemberForTransferCenterResponseReset),
	]);
}
